import styled, { DefaultTheme } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Checkbox } from '@/components/UI/Checkbox/Checkbox';
import { Button } from '@/components/UI/Button/Button';
import { VariantType } from '@/components/Ad/Status/PaymentFlow.types';

const variantColors = (theme: DefaultTheme): Record<VariantType, string> => ({
  bundle: theme.palette.secondary.background,
  vip: theme.palette.brand.vipGradient,
  featured: theme.palette.brand.premiumGradient,
});

export const Box = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-bottom: 20px;
  }
`;

export const Subtitle = styled(Typography.Body)`
  margin: 10px 0 20px;
`;

export const Variant = styled(Checkbox)<{
  $isActive: boolean;
  $type: VariantType;
}>`
  justify-content: initial;
  gap: 15px;
  padding: 20px 15px;
  height: 82px;
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.palette.primary.border};
  background: ${({ theme, $isActive, $type }) =>
    $isActive ? variantColors(theme)[$type] : theme.palette.primary.background};
  margin-bottom: 10px;
  transition: background-color 0.3s ease-in-out;
`;

export const VariantIconBox = styled.div`
  flex: 0 0 30px;
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const VariantTexts = styled.div`
  flex-grow: 1;
  display: grid;
  gap: 5px;
`;

export const ContinueButton = styled(Button)`
  margin-top: 30px;
  margin-bottom: 10px;
  border-radius: 14px;
`;

export const NeedMoreInfo = styled(Typography.Caption)`
  text-align: center;
  color: ${({ theme }) => theme.palette.secondary.labels};

  a {
    color: ${({ theme }) => theme.palette.system.blue};
    text-decoration: underline;
  }
`;

export const MultiplePrices = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const PrevPrice = styled(Typography.Caption).attrs(() => ({
  $variant: '1',
}))`
  color: ${({ theme }) => theme.palette.primary.labels};
  opacity: 0.6;
  text-decoration-line: line-through;
`;

export const NewPrice = styled(Typography.Caption).attrs(() => ({
  $variant: '1',
}))`
  font-weight: 700;
  color: ${({ theme }) => theme.palette.brand.main};
`;
